/**
 * @file ページの書き込みの過去の回の見せ方 (純関数) である。
 *
 * @what: 回の選択肢に出す日付の文字を作る。今年なら「9/12」、去年より前なら「2025/9/12」。
 * @why: 部品 (PageInkAttempts.tsx) から切り出して、テストしやすくする。
 * @failure: 日付が無ければ空文字を返す。
 */

export function attemptDateLabel(d: Date | null | undefined, now: Date = new Date()): string {
  if (!d) return "";
  const md = `${d.getMonth() + 1}/${d.getDate()}`;
  return d.getFullYear() === now.getFullYear() ? md : `${d.getFullYear()}/${md}`;
}
